export const APP_NAME = '{yourAppName}';
export const USER_NAME = '{userName}';
export const TENANT = '{yourTenant}';
export const NAMESPACE = '{yourDomain}';
export const CLIENT_ID = '{yourClientId}';
export const CLIENT_SECRET = '{yourClientSecret}';
export const CALLBACK = '{https://yourApp/callback}';
export const API_IDENTIFIER = '{yourApiIdentifier}';
export const CONNECTION_NAME = '{yourConnectionName}';
